import React from 'react';
import ViewContent from './view-content';

// styling
import './style.css';

export default () => (
    <div className="view">
        <div className="page-header">
            <h1 className="title">Dashboard</h1>
            <p className="subtitle">Latest statistics & summary</p>
        </div>
        <ViewContent/>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js